import { api } from 'src/services/api'

type Params = {
  accountId: string
}

type Response = {
  id: string
  key_type: string
  key: string
  status: string
  created_at: string
  updated_at: string
  ownership_date: string
}[]

export async function listPixKeys(params: Params) {
  try {
    const token = localStorage.getItem('@stricv2:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    if (user.role === 'ADMIN_BAG') {
      const response = await api.get<Response>(`/pix/keys`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } else {
      const response = await api.get<Response>(
        `/pix/keys/${user.virtual_account_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    }
  } catch (error) {
    console.error(error)
  }
}
